var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgBurguerMenu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.45C25 13.9852 24.528 13.6 23.9583 13.6H1.04167C0.472005 13.6 0 13.9852 0 14.45V16.15C0 16.6148 0.472005 17 1.04167 17H23.9583C24.528 17 25 16.6148 25 16.15V14.45ZM25 7.65C25 7.18516 24.528 6.8 23.9583 6.8H1.04167C0.472005 6.8 0 7.18516 0 7.65V9.35C0 9.81484 0.472005 10.2 1.04167 10.2H23.9583C24.528 10.2 25 9.81484 25 9.35V7.65ZM25 0.849999C25 0.385156 24.528 0 23.9583 0H1.04167C0.472005 0 0 0.385156 0 0.849999V2.55C0 3.01484 0.472005 3.4 1.04167 3.4H23.9583C24.528 3.4 25 3.01484 25 2.55V0.849999Z",
    fill: "#565656"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurguerMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burguerMenu.26695420.svg";
export { ForwardRef as ReactComponent };